import React, { useEffect, useRef } from 'react';
import { MuiCard, MuiTypography, MuiGrid, MuiToolTip, MuiRefreshIcon, MuiMenuItem, MuiEdit, MuiMoreVertIcon, MuiClickAwayListener, MuiPopper, MuiMenuList, MuiPaper, MuiIconButton, MuiVisibilityIcon, MuiFileCopyOutlinedIcon, MuiStarRateIcon } from '../../../ui/MaterialUIComponents';
import theme from '../../../../assests/theme';
import { Link } from 'react-router-dom';
import routes from "../../../navigation/Routes"
import { ScheduleConstants, geti18nStatusText } from './ScheduleConstants';
import ConfirmationofEditDialog from './ConfirmationofEditDialog'
import CreateScheduleDialog from './CreateScheduleDialog'
import { makeStyles } from '@material-ui/core/styles';
import spinner from '../../../ui/icons/spinner.gif'
import moment from 'moment';
import ConfirmDeleteScheduleDialog from './ConfirmDeleteScheduleDialog'
import ScheduleSummaryDialog from './ScheduleSummaryDialog'
import * as Constants from '../../../../constants';
import { rulesUtil } from '../rules/dialog'
import { setDataInLS } from '../../../../utils/LocalStorageUtil'
const useStyles = makeStyles(theme => ({

	printIconStyle: { height: '22px', width: '22px', paddingTop: 3 },
	spinnerStyle: { height: '40px', width: '40px' },
	mainGrid: { width: '100%', height: 'auto', background: "white" },
	headerGrid: { borderBottom: 'none', padding: 4 },
	headerGridText: { fontFamily: "Arial", fontSize: "24px", letterSpacing: "0px" },
	linkStyleIcon: { color: theme.palette.grey.darker, cursor: 'pointer', fontSize: "18px" },
	linkStyle: { color: theme.palette.grey.dark, cursor: 'pointer', fontSize: "14px", font: "Regular Arial" },
	iconSpacing: { padding: 5 },
	moreButtonGrid: { cursor: 'pointer' },
	moreButtonText: { fontSize: "14px", font: "Regular Arial", color: theme.palette.grey.dark },
	menuItemText: { color: 'black', fontSize: "12px", font: "Regular Arial", cursor: 'pointer', marginRight: '10px' },
	titleGrid: { background: theme.palette.grey.lightest, height: 'auto', display: 'flex' },
	summaryGrid: { padding: 6 },
	summaryText: { padding: 8, color: theme.palette.grey.dark, fontSize: "14px", fontWeight: 600, fontFamily: "Arial" },
	updateGridStyle: { padding: 8 },
	updateGridItemStyle: { height: '100%' },
	textStyle: { fontFamily: 'Arial', fontSize: '12px' },
	textStyle1: { fontFamily: 'Arial', color: theme.palette.orange, fontSize: '14px' },
	dateGrid: { padding: 8 },
	summaryMainGrid: { padding: 8, borderRight: '1px solid ' + theme.palette.grey.lighter }

}));

function ScheduleItemCard(props) {
	const [classesText, setClasses] = React.useState('');
	const [days, setDays] = React.useState('');
	const [periods, setPeriods] = React.useState('');
	const [openDeleteDialog, setOpenDialog] = React.useState(false);
	const [openEditNameDialog, setOpenEditNameDialogMethod] = React.useState(false);

	const [open, setOpen] = React.useState(false);
	const [openToolTip, setOpenToolTip] = React.useState(false);
	const anchorRef = React.useRef(null);
	const [openCreateScheduleDialog, setOpenCreateDialog] = React.useState(false);
	const [openScheduleSummaryDialog, setOpenScheduleSummaryDialog] = React.useState(false);
	const [openDialogForConfirmationFlag, setopenDialogForConfirmationOfEdit] = React.useState(false);
	const [timeTableRating, setTimeTableRating] = React.useState(0);
	const statusText = { fontSize: "14px", font: "Regular Arial", padding: "0px 20px", backgroundColor: theme.palette.primary.lighter, border: "1px solid", color: "black", borderRadius: 10 }
	const { i18n } = props
	let summaryAttributes = [
		{ name: i18n.schedule.days, value: days },
		{ name: i18n.schedule.periods, value: periods },
		{ name: i18n.schedule.classes, value: classesText },
		{ name: i18n.schedule.preference, value: props.schedule.preferenceCount },
		{ name: i18n.schedule.constraints, value: props.schedule.constraintCount },
	];
	const [tempScheduleName, setTempScheduleName] = React.useState(props.schedule.name);
	const [scheduleName, setScheduleName] = React.useState(props.schedule.name);
	const handleTooltipClose = () => {
		setOpenToolTip(false);
	};

	const handleTooltipOpen = () => {
		setOpenToolTip(true);
	};

	const handleToggle = () => {
		setOpen(prevOpen => !prevOpen);
	};
	const editScheduleNameDialog = () => {
		const { classes } = props

		let schedule = {}
		schedule = JSON.parse(JSON.stringify(props.schedule))
		return (
			<CreateScheduleDialog type="edit" title={i18n.schedule.editScheduleTitle} description={i18n.schedule.editScheduleDescription} toggleCreateScheduleDialogMethod={handleEditName} open={openEditNameDialog} scheduleObj={schedule} {...props} >
			</CreateScheduleDialog>

		)
	}
	const handleEditName = async () => {
		setOpenEditNameDialogMethod(prevOpen => !prevOpen);


	}
	const openDeleteDialogMethod = event => {
		setOpenDialog(prevOpen => !prevOpen);

	};
	const handleClose = event => {
		if (anchorRef.current && anchorRef.current.contains(event.target)) {
			return;
		}

		setOpen(false);
	};

	function handleListKeyDown(event) {
		if (event.key === 'Tab') {
			event.preventDefault();
			setOpen(false);
		}
	}

	const onClickOfDelete = async () => {

		props.onClickOfDelete(props.scheduleIndex, props.schedule);
		setOpenDialog(prevOpen => !prevOpen);
	}
	const handleCopy = async () => {
		setOpenCreateDialog(prevOpen => !prevOpen);


	}
	const printPropos = () => {
		console.log("******** Pringint props ", props);
	}

	const navigateTo = (path) => {
		props.history.push(path);
	}
	const handleShowSummary = async () => {
		let flag = !openScheduleSummaryDialog
		setOpenScheduleSummaryDialog(flag);
	}

	const createScheduleDialog = () => {
		const { classes } = props

		let schedule = {}
		schedule = JSON.parse(JSON.stringify(props.schedule))
		schedule = rulesUtil.deleteDirtyObjectsFromRules(schedule)
		schedule.name = ''
		schedule.timeTableDetails = null
		schedule.school_master = {}
		schedule.createdBy = null;
		schedule.createdDate = null;
		schedule.modifiedDate = null;
		schedule.lastPreCheckedDate = null;
		schedule.enableGenerateTimeTable = false;
		schedule.errorLog = {};
		schedule.status = null;
		delete schedule['_id']
		delete schedule['version']


		return (
			<CreateScheduleDialog type="create" title={i18n.schedule.copyScheduleTitle} description={i18n.schedule.copyScheduleDescription} toggleCreateScheduleDialogMethod={handleCopy} open={openCreateScheduleDialog} scheduleObj={schedule} {...props} >
			</CreateScheduleDialog>

		)
	}

	const dialogForConfirmationofEdit = () => {
		let pathName = routes.addNewRules
		let stateData = {
			activeSchool: props.activeSchool,
			activeScheduleId: props.schedule['_id'],
			scheduleIndex: props.scheduleIndex,
			stepperIndex: 0,
			disableEdit: false,
			overrideData: true
		}
		let schedule = schedule = JSON.parse(JSON.stringify(props.schedule))
		return (
			<ConfirmationofEditDialog
				//toggleShowMethod={openDialogForConfirmationOfEdit}
				cancel={openDialogForConfirmationOfEdit}
				open={openDialogForConfirmationFlag}
				schedule={props.schedule}
				pathName={pathName}
				stateData={stateData}
				{...props} >
			</ConfirmationofEditDialog>

		)

	}
	const scheduleSummaryDialogMethod = () => {

		return (
			<ScheduleSummaryDialog toggleShowMethod={handleShowSummary} open={openScheduleSummaryDialog} schedule={props.schedule} {...props} >
			</ScheduleSummaryDialog>

		)
	}
	const refreshPage = () => {
		window.location.reload(false);
	}
	function getStyleForStatusText(status) {
		let style = statusText;
		switch (status) {
			case ScheduleConstants.INPROGRESS:
				style.color = theme.palette.primary.dark;
				style.backgroundColor = theme.palette.primary.lighter
				style.border = "1px solid " + theme.palette.primary.dark

				return style;
				break;
			case ScheduleConstants.VERIFY:
				style.color = theme.palette.error.main;
				style.backgroundColor = theme.palette.error.light
				style.border = "1px solid " + theme.palette.error.main
				return style;
				break;
			case ScheduleConstants.VERIFIED:
				style.color = theme.palette.orangeDark;
				style.backgroundColor = theme.palette.orangeLight
				style.border = "1px solid " + theme.palette.orangeDark

				return style;
				break;
			case ScheduleConstants.COMPLETED:
				style.color = theme.palette.green.main;
				style.backgroundColor = theme.palette.green.light
				style.border = "1px solid " + theme.palette.green.main
				return style;
				break;
		}
	}


	const handleChange = (event) => {
		setScheduleName(event.target.value)
	}
	const deleteDialog = () => {
		const { classes } = props
		return (

			<ConfirmDeleteScheduleDialog {...props} onClickDelete={onClickOfDelete} sid={props.schedule["_id"]} name={props.schedule.name} cancel={cancel} open={openDeleteDialog} />
		)
	}
	const cancel = () => {
		setOpenDialog(prevOpen => !prevOpen);
	}
	const openDialogForConfirmationOfEdit = () => {
		setopenDialogForConfirmationOfEdit(prevOpen => !prevOpen)
	}
	const getClassesCount = (totalPeriods) => {
		let filteredTotalPeriods = totalPeriods.filter(function (obj) { return obj.gradeDetails.grades[0].groups.length > 0; })
		let classesCount = filteredTotalPeriods.reduce(function (acc, obj) { return acc + obj.count; }, 0)
		return classesCount;
	}
	const setData = () => {
		let weeklyCalendar = props.schedule.weeklyCalendar;
		let school = props.activeSchool;
		let totalPeriods = 0
		let numberOfDays = 0;
		let classesCount = 0;
		if (props.schedule.totalPeriods !== undefined) {
			classesCount = getClassesCount(props.schedule.totalPeriods);
		}
		if (weeklyCalendar !== undefined) {
			//weeklyCalendar.map(function (cal) {
			let cal = weeklyCalendar[0]
			if (cal != undefined) {
				let gradeDetails = cal.gradeDetails
				let master = school.school_master
				let periodsDetails = cal.periodsDetails
				for (let i = 0; i < periodsDetails.length; i++) {
					let dayObj = periodsDetails[i];
					if (dayObj.periods.length > 0) {
						numberOfDays++
					}
					for (let k = 0; k < dayObj.periods.length; k++) {
						if (dayObj.periods[k].typeOfPeriod == "period") {
							totalPeriods++;
						}
					}
				}
			}
			//})
		}
		if (props.schedule.status == ScheduleConstants.COMPLETED) {
			if (props.schedule.timeTableSummary != undefined) {
				let overScoreObject = props.schedule.timeTableSummary.find((obj) => obj.messagetype == "OverallScore")
				if (overScoreObject != undefined && overScoreObject.messageItem != undefined && overScoreObject.messageItem.value != undefined) {
					switch (overScoreObject.messageItem.value) {
						case "A": setTimeTableRating(3); break;
						case "A+": setTimeTableRating(3); break;
						case "B+": setTimeTableRating(2); break;
						case "B": setTimeTableRating(2); break;
						case "C+": setTimeTableRating(1); break;
						case "C": setTimeTableRating(1); break;
						default: setTimeTableRating(0); break;

					}

				}
			}
		}
		setPeriods(totalPeriods);
		setDays(numberOfDays)
		setClasses(classesCount)
	};
	const mounted = useRef();
	useEffect(() => {
		if (!mounted.current) {
			setData();
			mounted.current = true;
		} else {
			setData();
		}
	});
	const classes = useStyles();
	return (
		<MuiGrid container xs={12} direction="row" style={{}}>
			{openDeleteDialog ? deleteDialog() : null}
			{openCreateScheduleDialog ? createScheduleDialog() : null}
			{openScheduleSummaryDialog ? scheduleSummaryDialogMethod() : null}
			{openDialogForConfirmationFlag ? dialogForConfirmationofEdit() : null}
			{openEditNameDialog ? editScheduleNameDialog() : null}
			<MuiCard style={{ border: '1px solid ' + theme.palette.grey.main, background: theme.palette.grey.lightest }}>
				<MuiGrid container xs={12} className={classes.mainGrid} >
					<MuiGrid container xs={12} className={classes.headerGrid}>

						<MuiGrid container xs={12} >
							<MuiGrid container xs={4} justify='flex-start' alignItems="center" style={{ paddingLeft: 3 }}>
								<MuiGrid>
									<MuiTypography style={getStyleForStatusText(props.schedule.status)}>{props.schedule.status != undefined && geti18nStatusText(props.schedule.status, i18n)}</MuiTypography>
								</MuiGrid>




							</MuiGrid>

							<MuiGrid container xs justify='flex-end' align="right">
								<MuiGrid item >
									{!(props.schedule.status == ScheduleConstants.VERIFIED && props.schedule.enableGenerateTimeTable == false)
										? props.schedule.status != ScheduleConstants.COMPLETED ?
											<Link style={{ textDecoration: 'none' }} to={{
												pathname: routes.addNewRules,

											}} onClick={() => setDataInLS(Constants.STEPPER_STATE_KEY_LS, {
												activeSchool: props.activeSchool,
												activeScheduleId: props.schedule['_id'],
												scheduleIndex: props.scheduleIndex,
												stepperIndex: 0,
												disableEdit: false,
												overrideData: false
											})}>
												<MuiGrid container direction='column' justify='center' alignItems='center' className={classes.iconSpacing} >

													<MuiGrid item  >
														<MuiEdit className={classes.linkStyleIcon} />
													</MuiGrid>
													<MuiGrid item  >
														<MuiTypography className={classes.linkStyle}>

															{i18n.commonTexts.edit}
														</MuiTypography>
													</MuiGrid>
												</MuiGrid>

											</Link> :
											<Link onClick={openDialogForConfirmationOfEdit} style={{ textDecoration: 'none' }}>

												<MuiGrid container direction='column' justify='center' alignItems='center' className={classes.iconSpacing}>

													<MuiGrid item  >
														<MuiEdit className={classes.linkStyleIcon} />
													</MuiGrid>
													<MuiGrid item  >
														<MuiTypography className={classes.linkStyle}>
															{i18n.commonTexts.edit}

														</MuiTypography>
													</MuiGrid>
												</MuiGrid></Link>
										: null
									}
								</MuiGrid>
								{props.schedule.weeklyCalendar.length > 0 &&
									<MuiGrid item  >
										<Link style={{ textDecoration: 'none' }} to={{
											pathname: routes.addNewRules,

										}} onClick={() => setDataInLS(Constants.STEPPER_STATE_KEY_LS, {
											activeSchool: props.activeSchool,
											schedule: props.schedule,
											scheduleIndex: props.scheduleIndex,
											activeScheduleId: props.schedule['_id'],
											stepperIndex: 2,
											disableEdit: (props.schedule.status == ScheduleConstants.COMPLETED),
											overrideData: false
										})}>
											<MuiGrid container direction='column' justify='center' alignItems='center' style={{ padding: 5 }}>

												<MuiGrid item  >
													<MuiVisibilityIcon className={classes.linkStyleIcon} />
												</MuiGrid>
												<MuiGrid item  >
													<MuiTypography className={classes.linkStyle}>
														{i18n.schedule.viewDetails}
													</MuiTypography>
												</MuiGrid>
											</MuiGrid>

										</Link>
									</MuiGrid>}
								<MuiGrid item onClick={handleCopy} >
									<MuiGrid container direction='column' justify='center' alignItems='center' className={classes.iconSpacing} >

										<MuiGrid item  >
											<MuiFileCopyOutlinedIcon className={classes.linkStyleIcon} />
										</MuiGrid>
										<MuiGrid item  >
											<MuiTypography className={classes.linkStyle}>
												{i18n.commonTexts.copy}

											</MuiTypography>
										</MuiGrid>
									</MuiGrid>

								</MuiGrid>


								<MuiGrid item
									className={classes.moreButtonGrid}
									style={{ color: 'white', cursor: 'pointer' }} href=""
									ref={anchorRef}
									aria-controls={open ? 'menu-appbar' : undefined}
									aria-haspopup="true"
									onClick={handleToggle}
									justify='flex-start'>

									<MuiGrid container direction='column' justify='center' alignItems='center' className={classes.iconSpacing} >

										<MuiGrid item  >
											<MuiMoreVertIcon className={classes.linkStyleIcon} />
										</MuiGrid>
										<MuiGrid item  >
											<MuiTypography className={classes.linkStyle}>
												{i18n.commonTexts.more}

											</MuiTypography>
										</MuiGrid>
									</MuiGrid>
									{/* <MuiTypography className={classes.moreButtonText}>
										{i18n.commonTexts.more} </MuiTypography> */}

									<MuiPopper open={open} anchorEl={anchorRef.current} role={undefined} transition >

										<MuiPaper>
											<MuiClickAwayListener onClickAway={handleClose}>
												<MuiMenuList autoFocusItem={open} id="menu-appbar" onKeyDown={handleListKeyDown}>
													<MuiMenuItem onClick={handleClose}>
														<MuiTypography className={classes.menuItemText}
															variant="text" href="" onClick={openDeleteDialogMethod} >
															{i18n.commonTexts.delete}
														</MuiTypography></MuiMenuItem>
													<MuiMenuItem onClick={handleClose}>
														<MuiTypography className={classes.menuItemText}
															variant="text" href="" onClick={handleEditName} >
															{i18n.schedule.editScheduleName}
														</MuiTypography></MuiMenuItem>
												</MuiMenuList>
											</MuiClickAwayListener>
										</MuiPaper>
									</MuiPopper>
								</MuiGrid>
							</MuiGrid>
						</MuiGrid>
					</MuiGrid>

					<MuiGrid container alignItems='center' style={{ visibility: props.schedule.status == ScheduleConstants.VERIFIED && props.schedule.enableGenerateTimeTable == false ? "visible" : "hidden", paddingLeft: 5 }}>
						<MuiGrid align='left'
							style={{ cursor: "pointer" }}>
							<MuiToolTip title={<MuiTypography style={{ fontSize: '14px', color: 'white', }}>
								{i18n.schedule.generateIconToolTipText}</MuiTypography>} arrow classes={{ tooltip: classes.customWidth }} style={{ textTransform: 'none' }}>

								<img src={spinner} className={classes.spinnerStyle} />
								{/* <MuiTypography className={classes.textStyle}>{i18n.schedule.GeneratingTTText}
										</MuiTypography> */}
							</MuiToolTip>
						</MuiGrid>
						<MuiGrid align='center' >
							<MuiToolTip title={i18n.schedule.clickToRefresh} arrow classes={{ tooltip: classes.customWidth }} style={{ textTransform: 'none' }}>
								<MuiIconButton onClick={refreshPage}>
									<MuiRefreshIcon color='primary' fontSize='small' />
								</MuiIconButton>
							</MuiToolTip>
						</MuiGrid>
					</MuiGrid>
					<MuiGrid container xs={12}>

						<MuiGrid container xs={12}
							style={{ padding: 5 }}
						>
							{/* <Link style={{ textDecoration: 'none', width: '100%' }} to={{
									pathname: routes.addNewRules,
									state: {
										activeSchool: props.activeSchool,
										schedule: props.schedule,
										scheduleIndex: props.scheduleIndex,
										activeScheduleId: props.schedule['_id'],
										stepperIndex: 2,
										disableEdit: (props.schedule.status == ScheduleConstants.COMPLETED),
										overrideData: false
									}
								}}> */}

							<MuiGrid container xs={12} direction='row' align='center'>
								{summaryAttributes.map((attribute) => (
									<MuiGrid container xs direction='column'>
										<MuiGrid item  >
											<MuiTypography variant='caption' color='textSecondary'>
												{attribute.name} </MuiTypography>
										</MuiGrid>
										<MuiGrid item  >
											<MuiTypography style={theme.typography.h6}>
												{attribute.value} </MuiTypography>
										</MuiGrid>
									</MuiGrid>

								))}</MuiGrid>
							{/* </Link> */}
						</MuiGrid>

					</MuiGrid>
					<MuiGrid container xs={12} className={classes.titleGrid} align='left' >
						{/* <Link style={{ textDecoration: 'none' }} to={{
							pathname: routes.addNewRules,
							state: {
								activeSchool: props.activeSchool,
								schedule: props.schedule,
								scheduleIndex: props.scheduleIndex,
								activeScheduleId: props.schedule['_id'],
								stepperIndex: 2,
								disableEdit: (props.schedule.status == ScheduleConstants.COMPLETED),
								overrideData: false
							}
						}}> */}
						<MuiGrid container xs={12} className={classes.summaryGrid} >
							<MuiGrid container xs={12} >
								<MuiGrid item xs={props.schedule.status !== ScheduleConstants.COMPLETED ? 12 : 7}
									xl={props.schedule.status !== ScheduleConstants.COMPLETED ? 12 : 8}
									align='left' style={{ padding: 6 }}>
									<MuiClickAwayListener onClickAway={handleTooltipClose}>

										<MuiToolTip
											title={<MuiTypography style={{ fontSize: '14px', color: 'white', }}>
												{props.schedule.name}</MuiTypography>}
											PopperProps={{
												disablePortal: true,
											}}
											onClose={handleTooltipClose}
											open={openToolTip}
											disableFocusListener
											disableHoverListener
											disableTouchListener
											placement="bottom-start"
											style={{ textTransform: 'none' }}>

											<MuiTypography className={classes.headerGridText}
												onClick={handleTooltipOpen}
												style={{
													width: '100%',
													whiteSpace: 'nowrap',
													overflow: "hidden",
													textOverflow: "ellipsis",
													cursor: 'pointer'
												}}>
												{props.schedule.name != undefined && props.schedule.name}
											</MuiTypography>
										</MuiToolTip>
									</MuiClickAwayListener>
								</MuiGrid>

								{
									props.schedule.status == ScheduleConstants.COMPLETED ?
										<MuiGrid xs={3} xl={2} align='center'>
											<MuiGrid item>
												<MuiStarRateIcon fontSize="medium" style={{ color: timeTableRating > 0 ? theme.palette.orange : theme.palette.grey.main }} />
												<MuiStarRateIcon fontSize="medium" style={{ color: timeTableRating > 1 ? theme.palette.orange : theme.palette.grey.main }} />
												<MuiStarRateIcon fontSize="medium" style={{ color: timeTableRating > 2 ? theme.palette.orange : theme.palette.grey.main }} />
											</MuiGrid><MuiGrid item>
												<MuiTypography className={classes.textStyle1} style={{ cursor: 'pointer' }} onClick={props.schedule.timeTableSummary != undefined && props.schedule.timeTableSummary.length > 0 ? handleShowSummary : null} >
													{i18n.schedule.score}
												</MuiTypography>
											</MuiGrid></MuiGrid>
										: null
								}
								{
									props.schedule.status == ScheduleConstants.COMPLETED ?
										<MuiGrid item xs={2}>
											<Link style={{ textDecoration: 'none', cursor: 'pointer' }} to={{
												pathname: routes.addNewRules,

											}} onClick={() => setDataInLS(Constants.STEPPER_STATE_KEY_LS, {
												activeSchool: props.activeSchool,
												schedule: props.schedule,
												scheduleIndex: props.scheduleIndex,
												activeScheduleId: props.schedule['_id'],
												stepperIndex: 2,
												disableEdit: (props.schedule.status == ScheduleConstants.COMPLETED),
												overrideData: false
											})}>



												<MuiGrid align='center'	>
													<MuiGrid item>
														<img src={theme.imageAlbum.timeTableBlueIcon} className={classes.printIconStyle} />
													</MuiGrid><MuiGrid item>
														<MuiTypography style={{ fontFamily: 'Arial', color: theme.palette.primary.main, fontSize: '14px', cursor: 'pointer' }}>

															{i18n.schedule.timeTable}

														</MuiTypography>
													</MuiGrid></MuiGrid>

											</Link>
										</MuiGrid>
										: null
								}


							</MuiGrid>

							<MuiGrid container xs={12} justify='space-between'>
								<MuiGrid item xs className={classes.dateGrid} >
									<MuiTypography variant='caption' color='textSecondary'>
										{i18n.commonTexts.createdOn}
									</MuiTypography>
									<MuiTypography style={theme.typography.span}>
										{props.schedule.createdDate != undefined && moment(props.schedule.createdDate).format('DD-MMM-YYYY hh:mm A')}
									</MuiTypography>
								</MuiGrid>
								<MuiGrid item className={classes.dateGrid} >
									<MuiTypography variant='caption' color='textSecondary'>
										{i18n.commonTexts.lastModifiedOn} </MuiTypography>
									<MuiTypography style={theme.typography.span}> {props.schedule.modifiedDate != undefined && moment(props.schedule.modifiedDate).format('DD-MMM-YYYY hh:mm A')}
									</MuiTypography>
								</MuiGrid>	</MuiGrid>
						</MuiGrid>
						{/* </Link> */}
					</MuiGrid>
				</MuiGrid>
			</MuiCard>
		</MuiGrid >
	)

}

export default ScheduleItemCard;